module.exports = __webpack_public_path__ + "static/media/create-virtual-card-48x48.5bbf1969.svg";